import reducer from './reducers';

import * as personalDetailsSelectors from './selectors';
import * as personalDetailsOperations from './operations';
import * as personalDetailsTypes from './types';

export { personalDetailsSelectors, personalDetailsOperations, personalDetailsTypes };

export default reducer;
